export const baseCompaniesPerPage = 10
export const basePerPage = 20

export const baseItemsPerTablePage = 10

export const SEARCH_INPUT_DEBOUNCE = 600

export const userStatuses = {
  active: {
    value: '1',
    label: 'Active',
  },
  blocked: {
    value: '2',
    label: 'Blocked',
  },
  invited: {
    value: '0',
    label: 'Waiting accept invite',
  },
}

export const sortOptions = {
  id: 'id',
  email: 'email',
  fullName: 'firstName',
  createdAt: 'createdAt',
  title: 'title',
  number: 'number',
  propertyTitle: 'propertyTitle',
  companyCount: 'companyCount',
  employeeCount: 'employeeCount',
}

export const orderOptions = {
  ascend: 'asc',
  descend: 'desc',
}

export const enquiryStatuses = [
  {
    value: '0',
    label: 'New',
  },
  {
    value: '3',
    label: 'Rejected',
  },
  {
    value: '1',
    label: 'In Progress',
  },
  {
    value: '2',
    label: 'Completed',
  },
]

export const companiesSortOptions = {
  id: 'id',
  slug: 'slug',
  companyName: 'name',
}

export const metersToFeets = 10.764

export const sizeTabs = [
  {
    label: 'Sqm',
    value: 'Sqm',
    action: (val) => Math.round(val / metersToFeets),
  },
  {
    label: 'Sqft',
    value: 'Sqft',
    action: (val) => Math.round(val * metersToFeets),
    convert: (val) => Math.round(val / metersToFeets),
  },
]

export const bedroomsData = {
  label: 'Bedrooms',
  suffix: 'Bedroom',
  values: {
    '-1': 'Hotel room',
    0: 'Studio',
    1: '1',
    2: '2',
    3: '3',
    4: '4',
    5: '5',
    6: '6',
    7: '7',
    8: '8',
    9: '9',
    10: '10+',
  },
}

export const DATE_FORMAT = 'DD/MM/YYYY'
export const DATE_FORMAT_ALT = 'DD-MM-YYYY'
export const DATE_FORMAT_QUERY = 'YYYY-MM-DD'
export const DATE_FULL_FORMAT = 'DD.MM.YYYY HH:mm'
export const DATE_FULL_FORMAT_WITH_SECONDS = 'DD.MM.YYYY HH:mm:ss'
export const DATE_FORMAT_YEAR = 'YYYY'
export const DATE_FORMAT_MONTH_YEAR = 'MMMM, YYYY'
export const DATE_FORMAT_CALENDAR = 'MMM yyyy'
export const TIME_FORMAT = 'h:MMA'
export const DATE_AND_TIME_FORMAT = `${DATE_FORMAT} h:mmA`
export const DATEPICKER_DATE_FORMAT = 'MMM dd, yyyy'
export const STANDARD_MEDIUM_DATE_FORMAT = 'MMM DD, YYYY'
export const DATE_FORMAT_LONG = 'ddd DD MMM, YYYY'

export const timezoneOptions = [
  { label: '-12:00', value: '-12:00' },
  { label: '-11:00', value: '-11:00' },
  { label: '-10:00', value: '-10:00' },
  { label: '-09:30', value: '-09:30' },
  { label: '-09:00', value: '-09:00' },
  { label: '-08:00', value: '-08:00' },
  { label: '-07:00', value: '-07:00' },
  { label: '-06:00', value: '-06:00' },
  { label: '-05:00', value: '-05:00' },
  { label: '-04:00', value: '-04:00' },
  { label: '-03:30', value: '-03:30' },
  { label: '-03:00', value: '-03:00' },
  { label: '-02:00', value: '-02:00' },
  { label: '-01:00', value: '-01:00' },
  { label: '±00:00', value: '±00:00' },
  { label: '+01:00', value: '+01:00' },
  { label: '+02:00', value: '+02:00' },
  { label: '+03:00', value: '+03:00' },
  { label: '+03:30', value: '+03:30' },
  { label: '+04:00', value: '+04:00' },
  { label: '+04:30', value: '+04:30' },
  { label: '+05:00', value: '+05:00' },
  { label: '+05:30', value: '+05:30' },
  { label: '+05:45', value: '+05:45' },
  { label: '+06:00', value: '+06:00' },
  { label: '+06:30', value: '+06:30' },
  { label: '+07:00', value: '+07:00' },
  { label: '+08:00', value: '+08:00' },
  { label: '+08:45', value: '+08:45' },
  { label: '+09:00', value: '+09:00' },
  { label: '+09:30', value: '+09:30' },
  { label: '+10:00', value: '+10:00' },
  { label: '+10:30', value: '+10:30' },
  { label: '+11:00', value: '+11:00' },
  { label: '+12:00', value: '+12:00' },
  { label: '+12:45', value: '+12:45' },
  { label: '+13:00', value: '+13:00' },
]

export const contacts = {
  EMEA: '+44 2080 394009',
  US: '+1 888-308-4010',
  APAC: '+65 3174-6217',
}

export const ascend = 'ascend'
export const descend = 'descend'

export const orderMap = {
  asc: ascend,
  desc: descend,
}

export const maxSizes = { sqm: 15000, sqft: 150000 }

export const DEFAULT_MAX_FILE_SIZE = 5242880 // 5 MB
export const INCREASED_MAX_FILE_SIZE = 52428800 // 50 MB

export const MAX_BIG_INT = 2147483647

export const SHORT_HEX_REG_EXP = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
export const LONG_HEX_REG_EXP = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i
// eslint-disable-next-line no-template-curly-in-string
export const FORM_VALIDATE_MESSAGES = { required: '${label} is required!' }

export const SIZE_UNITS = {
  sqm: '1',
  sqft: '2',
}

export const SIZE_UNITS_OPTIONS_RATE_CALCULATOR = [
  { value: '1', label: 'sqm' },
  { value: '2', label: 'sqft' },
]

export const DISTANCE_UNITS = {
  km: 'km',
  mi: 'mi',
}

export const DISTANCE_UNITS_OPTIONS = [
  { value: 'km', label: 'km' },
  { value: 'mi', label: 'mi' },
]

export const SIZE_UNITS_HOR = {
  sqm: '0',
  sqft: '1',
}

export const SIZE_UNITS_OPTIONS_HOR = [
  { value: '0', label: 'sqm' },
  { value: '1', label: 'sqft' },
]

export const PARKING_INCLUDED_VALUE = '1'
export const PARKING_NONE_VALUE = '0'

export const PARKING_FIELD_OPTIONS = [
  { value: PARKING_INCLUDED_VALUE, label: 'Yes' },
  { value: PARKING_NONE_VALUE, label: 'No' },
]

export const PET_FRIENDLY_REQUIRED_FIELD_OPTIONS = [
  { value: PARKING_INCLUDED_VALUE, label: 'Yes' },
  { value: PARKING_NONE_VALUE, label: 'No' },
]

export const NBSP = '\u00A0'

export const HTML_ENTITIES = {
  NBSP,
}
